import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'

interface ClientUserReassignModalProps {
  open: boolean
  oldEmail: string
  newEmail: string
  onConfirm: () => void
  onCancel: () => void
}

export function ClientUserReassignModal({
  open,
  oldEmail,
  newEmail,
  onConfirm,
  onCancel,
}: ClientUserReassignModalProps) {
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onCancel() }}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Reassign Engagement</DialogTitle>
          <DialogDescription>
            You are reassigning this engagement from{' '}
            <span className="font-medium text-foreground">{oldEmail}</span> to{' '}
            <span className="font-medium text-foreground">{newEmail}</span>. This will
            change which user can view this engagement on their dashboard.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button onClick={onConfirm}>Confirm Reassign</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
